export default "__VITE_ASSET__BZZrOetu__"